import React from 'react';

import { get_zone_data, get_province_data, get_hos_data } from '../Database'

import convertToOptions from '../FormatData/convertToOptions';
import { zone_all, province_all, zone_query_str, province_query_str, hospital_all, hospital_query_str } from './Const/label';

class DrillDownDropBox extends React.Component {

    componentDidMount() {
        get_zone_data().then((result_zone) => {
            const zone = this.props.zone || zone_all.value
            get_province_data(zone).then((result_province) => {
                const province = this.props.province || province_all.value
                get_hos_data(province).then((result_hospital) => {
                    this.setState({
                        zone_data: convertToOptions(result_zone, zone_query_str, zone_all.value, zone_all.label),
                        province_data: convertToOptions(result_province, province_query_str, province_all.value, province_all.label),
                        hospital_data: convertToOptions(result_hospital, hospital_query_str, hospital_all.value, hospital_all.label)
                    })
                })
            })
        })
    }

    componentDidUpdate(prevProps, prevStates, snapshot) {
        if (prevProps.province !== this.props.province) {
            get_hos_data(this.props.province).then((result_hospital) => {
                this.setState({
                    hospital_data: convertToOptions(result_hospital, hospital_query_str, hospital_all.value, hospital_all.label)
                })
            })
        }
        if (prevProps.zone !== this.props.zone) {
            get_province_data(this.props.zone).then((result_province) => {
                const province = this.props.province || province_all.value
                get_hos_data(province).then((result_hospital) => {
                    this.setState({
                        province_data: convertToOptions(result_province, province_query_str, province_all.value, province_all.label),
                        hospital_data: convertToOptions(result_hospital, hospital_query_str, hospital_all.value, hospital_all.label)
                    })
                })
            })
        }
    }

    render() {
        if (!this.state)
            return <div>something wrong</div>
        return (
            <label>
                <select
                    // ถ้าไม่มีค่า props.zone ให้ใช้ค่า zone_all แทน
                    value={this.props.zone || zone_all.value}
                    onChange={e => this.props.changezone(e.target.value)}>
                    {this.state.zone_data.map(o => (
                        <option key={o.value} value={o.value}>{o.label}</option>
                    ))}&nbsp;
                </select>
                {/* ถ้ามีการเลือก zone (ไม่เท่ากับ nul undefined และไม่เท่ากับ zone_all) ให้แสดงส่วนที่เลือก province */}
                {this.props.zone && this.props.zone !== zone_all.value && <select
                    // ถ้าไม่มีค่า props.province ให้ใช้ค่า province_all แทน
                    value={this.props.province || province_all.value}
                    onChange={e => this.props.changeprovince(e.target.value)}>
                    {this.state.province_data.map(o => (
                        <option key={o.value} value={o.value}>{o.label}</option>
                    ))}
                </select>
                }
                {/* ถ้ามีการเลือก province (ไม่เท่ากับ nul undefined และไม่เท่ากับ province_all) ให้แสดงส่วนที่เลือก hospital */}
                {this.props.province && this.props.province !== province_all.value && <select
                    // ถ้าไม่มีค่า props.hospital ให้ใช้ค่า hospital_all แทน
                    value={this.props.hospital || hospital_all.value}
                    onChange={e => this.props.changehospital(e.target.value)}>
                    {this.state.hospital_data.map(o => (
                        <option key={o.value} value={o.value}>{o.label}</option>
                    ))}
                </select>
                }
            </label>
        )
    }
}

export default DrillDownDropBox;